<div class="notif-panel" (click)="$event.stopPropagation()">
  <div class="notif-panel__head">
    <span class="notif-panel__title">Notifications</span>
    <span class="notif-panel__count" *ngIf="unreadCount">{{ unreadCount }} non lue{{ unreadCount > 1 ? 's' : '' }}</span>
  </div>

  <div class="notif-panel__list">
    <ng-container *ngIf="notifications?.length; else emptyState">
      <button
        type="button"
        class="notif-item"
        *ngFor="let item of notifications; trackBy: trackById"
        [class.notif-item--unread]="!item.read"
        (click)="onItemClick(item, $event)"
      >
        <span class="notif-item__avatar">
          <svg-icon src="assets/icons/notif.svg"></svg-icon>
        </span>

        <span class="notif-item__body">
          <span class="notif-item__title">{{ item.title }}</span>
          <span class="notif-item__text">{{ getDisplayContent(item.content) }}</span>
          <span class="notif-item__meta">
            <span class="notif-item__time">{{ item.created_at | timeAgo }}</span>
            <span class="notif-item__delivered" *ngIf="item.delivered_at" [title]="item.delivered_at">
              · Livré à {{ formatDeliveredTime(item.delivered_at) }}
            </span>
          </span>
        </span>

        <span class="notif-item__dot" *ngIf="!item.read" aria-label="non lu"></span>
      </button>
    </ng-container>

    <ng-template #emptyState>
      <div class="notif-empty">
        <svg-icon src="assets/icons/notif.svg" class="notif-empty__icon"></svg-icon>
        <span>Aucune notification</span>
      </div>
    </ng-template>
  </div>
</div>
